import { MESSAGE_BOX_VARIANT_INFO, MessageBox } from 'mailup-web-components'
import PropTypes from 'prop-types'

import { useIntl } from 'react-intl'
import { CASE_6 } from '../ModalSmsSender'

const InfoMessageDescriptionNoGuest = ({ isTrial, items, caseState }) => {
  const intl = useIntl()

  return (
    caseState === CASE_6 && (
      <MessageBox variant={MESSAGE_BOX_VARIANT_INFO}>
        {intl.formatMessage({
          id: 'Load.WarningAlias.DescriptionNoGest'
        })}
      </MessageBox>
    )
  )
}

InfoMessageDescriptionNoGuest.propTypes = {
  isTrial: PropTypes.bool,
  items: PropTypes.array,
  caseState: PropTypes.number
}

export default InfoMessageDescriptionNoGuest
